const statuses = {
  new: { label: 'New', color: 'amber', description: 'Awaiting confirmation from the restaurant’s POS.' },
  received: { label: 'Received', color: 'blue', description: 'The restaurant’s POS has received the order.' },
  awaiting_collection: { label: 'Ready', color: 'green', description: 'The restaurant reports the order is ready.' },
  awaiting_shipment: { label: 'Ready', color: 'green', description: 'The restaurant reports the order is ready.' },
  completed: { label: 'Completed', color: 'gray', description: 'The POS reports this order completed.' },
  rejected: { label: 'Rejected', color: 'red', description: 'The restaurant system could not accept this order. Please ask our team.' },
  cancelled: { label: 'Cancelled', color: 'red', description: 'This order has been cancelled. Please ask our team if you need help.' },
  accepted: { label: 'Accepted', color: 'blue', description: 'The restaurant has accepted the order.' },
  in_preparation: { label: 'Preparing', color: 'blue', description: 'The connected restaurant system reports the order is being prepared.' },
  // Some connected apps use a delivery stage even for our dine-in orders.
  // Keep the raw HubRise state, but do not imply delivery or completion.
  in_delivery: { label: 'In progress', color: 'blue', description: 'The restaurant system reports this order is still in progress.' },
  delivery_failed: { label: 'Failed', color: 'red', description: 'The restaurant system could not complete this order. Please ask our team.' },
};

export function orderStatus(value) {
  return statuses[value] || { label: value ? value.replace(/_/g, ' ').replace(/^./, letter => letter.toUpperCase()) : 'Unknown', color: 'gray', description: 'Status reported by the connected restaurant system.' };
}

export const statusLabel = value => orderStatus(value).label;
export const terminalOrderStatus = value => ['completed', 'rejected', 'cancelled', 'delivery_failed', 'served'].includes(value);


export const LIVE_ORDER_STAGES = [
  { id: 'new', name: 'New / Received' },
  { id: 'in_progress', name: 'In progress' },
  { id: 'ready', name: 'Ready' },
  { id: 'completed', name: 'Completed' },
  { id: 'not_completed', name: 'Not completed' },
  { id: 'other', name: 'Other statuses' },
];

export function orderLane(status) {
  if (['new', 'received', 'accepted'].includes(status)) return 'new';
  if (['in_preparation', 'in_delivery'].includes(status)) return 'in_progress';
  if (['awaiting_collection', 'awaiting_shipment'].includes(status)) return 'ready';
  if (status === 'completed') return 'completed';
  if (['rejected', 'cancelled', 'delivery_failed'].includes(status)) return 'not_completed';
  return 'other';
}
